module.exports = __webpack_public_path__ + "static/media/A7402189.bdc9ee38.jpg";